module.exports = __webpack_public_path__ + "img/top.31148350.png";